import { Injectable } from "@angular/core";
import { CtBinaryOperator, CtControlConfiguration, CtFormContainerHelper, CTModelDatatableFilter } from "@ctsolution/ct-framework";

@Injectable({
    providedIn: "root",
})

export class CustomCtFormContainerHelper extends CtFormContainerHelper {
    // Sovrascrivi solo il metodo che permette la customizzazione

    protected override customizeAdditionalLookupFilter(configuration: CtControlConfiguration): Array<CTModelDatatableFilter>{

        if(configuration.CTFieldInfo?.Field === 'Company' || configuration.CTFieldInfo?.Field === 'Contact' || configuration.CTFieldInfo?.Field === 'Customer' || configuration.CTFieldInfo?.Field === 'Supplier')
        {

                const filter: CTModelDatatableFilter = CTModelDatatableFilter
                .create()
                .setField("[Oid] = ? OR [Active] = ?")
                .setValue([configuration.control?.value?.value ?? null,true])
                .setOperatorType(CtBinaryOperator.OrOperator); 

                return [filter]

        }

        return []
    }

    getFilterForLookupCompanyOrContact(configuration: CtControlConfiguration){

        const filter: CTModelDatatableFilter = CTModelDatatableFilter
        .create()
        .setField("[Oid] = ? OR [Active] = ?")
        .setValue([configuration.control?.value?.value ?? null,true])
        .setOperatorType(CtBinaryOperator.OrOperator); 

        return filter

    }

}